import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class CardComponent implements OnInit, OnChanges{
  @Input({ required: true }) bgColor!: string;
  @Input() radius?: string;

  mainStyle: any = {};

  ngOnInit(): void {
    this.getStyles();
  }

  ngOnChanges(changes: any): void {
    this.getStyles();
    if (changes.bgColor?.currentValue) {
      this.mainStyle['background-color'] = changes.bgColor.currentValue;
    }

    if (changes.radius?.currentValue) {
      this.mainStyle.borderRadius = changes.radius.currentValue;
    }
  }

  getStyles(){
    this.mainStyle['background-color'] = this.bgColor;
    this.mainStyle.borderRadius = this.radius || '0px';
  }
}
